import { Component } from '@angular/core';

// Todo: maybe add translations in the future?
@Component({
    selector: 'payments-portal-maintenance',
    template: `
        <div class="w-screen h-screen flex justify-center bg-[#f2f2f2] text-[#0c1c34]">
            <div class="m-10 flex flex-col justify-center items-center gap-3">
                <div class="text-8xl font-medium">We are under maintenance</div>
                <div class="text-2xl text-center max-w-prose">
                    Sorry for the inconvenience! We are currently updating servers to improve our services. We should be
                    back online shortly. Thank you for your patience!
                </div>
                <div class="text-xl text-right mt-3">
                    But you can always
                    <a class="text-[#ff6050] font-medium" href="https://ridango.com/contact/">contact us</a>.
                </div>
            </div>
        </div>
    `,
    standalone: false
})
export class MaintenanceComponent {}
